import React from "react";
import UserSessionListItem from "../../components/userSession/UserSessionList/UserSessionListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const UserSessionListPage = ()  => {

    useTitle(t`List User Session`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <UserSessionListItem showAdd={true} {...query} />
        </Box>
    )
}

export default UserSessionListPage;
